import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { MaintenanceService } from '@riise/core/services/maintenance/maintenance.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private maintenanceService = inject(MaintenanceService);
    private router = inject(Router);
    private translateService = inject(TranslateService);
    private isTimeoutSwalOpen = false;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                const maintenanceErrors = [0, 502, 503];
                const criticalErrors = [404, 408, 500];

                console.warn('ErrorInterceptor caught error:', {
                    status: error.status,
                    message: error.message,
                    url: error.url,
                    error: error
                });

                if (!navigator.onLine) {
                    this.maintenanceService.showMaintenancePage('offline');
                } else if (error.status == 504 || +error.status === 504) {
                    if (!this.isTimeoutSwalOpen) {
                        this.isTimeoutSwalOpen = true;
                        Swal.fire({
                            title: this.translateService.instant("Le serveur met du temps à répondre"),
                            text: this.translateService.instant("Les données prennent plus de temps que prévu à charger. Voulez-vous actualiser la page ?"),
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: this.translateService.instant("Actualiser"),
                            cancelButtonText: this.translateService.instant("Attendre"),
                            confirmButtonColor: '#06C777',
                            cancelButtonColor: '#d33',
                        }).then((result) => {
                            this.isTimeoutSwalOpen = false;
                            if (result.isConfirmed) {
                                window.location.reload();
                            }
                        });
                    }
                } else if (maintenanceErrors.includes(error.status) || maintenanceErrors.includes(+error.status)) {
                    this.maintenanceService.showMaintenancePage('maintenance');
                } else if (criticalErrors.includes(error.status)) {
                    this.router.navigate(['/error'], { queryParams: { status: error.status } });
                }
                return throwError(() => error);
            })
        );
    }
}
